<template>
  <div class="expresscheckout">
    <h2>{{$t('shopping.express_checkout')}}</h2>
    <div class="buttonbox">
      <div id="paypal-button" :pixel="pixel" :cartmes='JSON.stringify(cartmes)'></div>
    </div>
    <div class="or">
      <span>{{$t('shopping.or')}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["pixel",'cartmes']
  
};
</script>
<style scoped lang='scss'>
.expresscheckout {
  margin-top: 21px;
  h2 {
    font-size: 1em;
    font-weight: 500;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    -ms-flex-align: end;
    align-items: flex-end;
    text-align: center;
    color: #333333;
    &::before,
    &::after {
      content: "";
      border: 1px #e6e6e6 solid;
      border-bottom: 0;
      height: 8px;
      -webkit-box-flex: 1;
      -webkit-flex: 1 0 16px;
      -ms-flex: 1 0 16px;
      flex: 1 0 16px;
    }
    &::before {
      border-right: 0;
      border-top-left-radius: 5px;
      margin-right: 14px;
    }
    &::after {
      border-left: 0;
      border-top-right-radius: 5px;
      margin-left: 14px;
    }
  }
  .buttonbox {
    border: 1px #e6e6e6 solid;
    border-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 13px 20px 20px;
  }
  .or {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
    text-transform: uppercase;
    color: #737373;
    margin-top: 30px;
    margin-bottom: 28px;
    span {
      display: inline-block;
      padding: 0 8px;
    }
    &::after {
      content: "";
      display: inline-block;
      height: 1px;
      background-color: #e6e6e6;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
    }
    &::before {
      content: "";
      display: inline-block;
      height: 1px;
      background-color: #e6e6e6;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
    }
  }
}
</style>